import { useContext, useEffect } from 'react';
import { changeWebPageTitleService } from '../../../infrastructure/services';
import { AppContext } from '../../../main/context/Provider';
import { Private_Routes } from '../../../main/constants';
import { ProjectForm } from '../components/form/ProjectForm';

export const CreateProjectPage = () => {
    const { setNestedRoutes, isSkinSmart, lang } = useContext(AppContext);

    const { webPage } = changeWebPageTitleService(isSkinSmart, 'Crear Proyecto');

    useEffect(() => {
        setNestedRoutes([
            {
                label: 'Proyectos',
                route: Private_Routes.PROJECT_PAGE,
            },
            {
                label: webPage,
                route: Private_Routes.CREATE_PROJECT,
            },
        ]);
    }, [lang]);

    return <ProjectForm isNewProject={true} />;
};
